import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col items-start gap-1" };
const _hoisted_2 = {
    key: 0,
    class: "text-xs text-(--colors-text-body-subtle)",
    "data-testid": "donation-refusal-reason"
};
import { Badge } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { shownRefusalReason } from "../../domain/entities/Donation";
import { donationStatusIcon, donationStatusTheme } from "../composables/donationStatusBadge";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationStatusBadge',
    props: {
        donation: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const refusalReason = computed(() => shownRefusalReason(props.donation));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Badge), {
                    label: _unref(t)(`finance.donations.status.${__props.donation.status}`),
                    theme: _unref(donationStatusTheme)[__props.donation.status],
                    "show-close-icon": false,
                    size: "sm",
                    "left-icon": _unref(donationStatusIcon)[__props.donation.status]
                }, null, 8 /* PROPS */, ["label", "theme", "left-icon"]),
                (refusalReason.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)(`finance.donations.refusalReason.${refusalReason.value}`)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
